import React from 'react';
import { Controller } from 'react-hook-form';
import { useFormContext } from './FormProvider';
import PropTypes from 'prop-types';
import NumberInput from '../NumberInput/NumberInput';

export const FormNumber = ({ name, ...props }) => {
  const { control, formConfig } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <NumberInput
          {...field}
          {...formConfig}
          {...props}
          error={!!error}
          helperText={error?.message ? error?.message : props.helperText}
        />
      )}
    />
  );
};

FormNumber.propTypes = {
  name: PropTypes.string.isRequired,
}; 